export const SNILS_LENGTH = 11

export const getSnilsError = (snils: string) => {
  if (!snils.length) {
    return 'Не заполнено поле СНИЛС'
  } else if (/[^0-9]/.test(snils)) {
    return 'СНИЛС может состоять только из цифр'
  } else if (snils.trim().length !== 11) {
    return `СНИЛС может состоять только из ${SNILS_LENGTH} цифр`
  } else if (snils.split('').every((item) => Number(item) === 0)) {
    return 'Неверное значение СНИЛС. Убедитесь, что указанное значение совпадает со значением в документе'
  }

  let sum = 0

  for (let i = 0; i < 9; i++) {
    sum += parseInt(snils[i]) * (9 - i)
  }
  let checkDigit = 0
  if (sum < 100) {
    checkDigit = sum
  } else if (sum > 101) {
    checkDigit = parseInt(String(sum % 101))
    if (checkDigit === 100) {
      checkDigit = 0
    }
  }
  if (checkDigit !== parseInt(snils.slice(-2))) {
    return 'Неверное значение СНИЛС. Убедитесь, что указанное значение совпадает со значением в документе'
  }
}
